import { memo } from 'react';
import { LayersControl } from 'react-leaflet';
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';

import { GOOGLE_LAYER } from './constants';

const { BaseLayer } = LayersControl;

const key = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

const layers = [
  {
    name: 'Google Maps Satellite',
    isChecked: true,
    type: GOOGLE_LAYER.HYBRID
  },
  {
    name: 'Google Maps Terrain',
    isChecked: false,
    type: GOOGLE_LAYER.TERRAIN
  }
];

function BaseLayers() {
  return (
    <>
      {layers.map(layer => (
        <BaseLayer key={layer.type} checked={layer.isChecked} name={layer.name}>
          <ReactLeafletGoogleLayer apiKey={key} type={layer.type} />
        </BaseLayer>
      ))}
    </>
  );
}

export default memo(BaseLayers);
